module.exports = __webpack_public_path__ + "img/student-2.b7cda541.jpg";